export const ARYA_SUPPORT_CHAT_ROUTE = '/m/arya?support=1';

// Set on the message, not shared composer state, so ordinary Arya chats stay
// ordinary chats. The server's support preprocessor also recognizes this
// persisted marker for follow-ups and restored conversations.
export function buildSupportChatMessage(message, modelId) {
  return {
    ...message,
    modelIds: [modelId],
    agentIds: [],
    botId: null,
    actions: [],
    fastMode: false,
    parameters: {
      ...message.parameters,
      ___isSupportQuery: true,
      ___supportChat: true,
      ___workModeChoice: 'chat',
      ___isAutoMode: false,
      ___displayModelIds: [modelId],
    },
  };
}
